
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import UserAuthorisedCreditBureauReferenceManyToMany from '../Security/Acl/UserAuthorisedCreditBureauReferenceManyToMany';
import VisitorsAuthorisedCreditBureauReferenceManyToMany from '../Security/Acl/VisitorsAuthorisedCreditBureauReferenceManyToMany';

// Botwritten code is breaking this rule, and we can't really avoid it
/* eslint max-len: 0 */

export interface IOrganisationAuthorisedCreditBureauAttributes extends IModelAttributes {
	organisationId: string;
	authorisedCreditBureauId: string;

	organisation: Models.OrganisationEntity | Models.IOrganisationEntityAttributes;
	authorisedCreditBureau: Models.CreditBureauEntity | Models.ICreditBureauEntityAttributes;

}

@entity('OrganisationAuthorisedCreditBureau')
export default class OrganisationAuthorisedCreditBureau
	extends Model
	implements IOrganisationAuthorisedCreditBureauAttributes {
	public static acls: IAcl[] = [
		new UserAuthorisedCreditBureauReferenceManyToMany(),
		new VisitorsAuthorisedCreditBureauReferenceManyToMany(),

	];

	@observable
	@attribute()
	public organisationId: string;

	@observable
	@attribute()
	public authorisedCreditBureauId: string;

	@observable
	@attribute({ isReference: true })
	public organisation: Models.OrganisationEntity;

	@observable
	@attribute({ isReference: true })
	public authorisedCreditBureau: Models.CreditBureauEntity;


	constructor(attributes?: Partial<IOrganisationAuthorisedCreditBureauAttributes>) {

		super(attributes);

		if (attributes) {
			if (attributes.organisationId) {
				this.organisationId = attributes.organisationId;
			}
			if (attributes.authorisedCreditBureauId) {
				this.authorisedCreditBureauId = attributes.authorisedCreditBureauId;
			}

			if (attributes.organisation) {
				if (attributes.organisation instanceof Models.OrganisationEntity) {
					this.organisation = attributes.organisation;
					this.organisationId = attributes.organisation.id;
				} else {
					this.organisation = new Models.OrganisationEntity(attributes.organisation);
					this.organisationId = this.organisation.id;
				}
			} else if (attributes.organisationId !== undefined) {
				this.organisationId = attributes.organisationId;
			}

			if (attributes.authorisedCreditBureau) {
				if (attributes.authorisedCreditBureau instanceof Models.CreditBureauEntity) {
					this.authorisedCreditBureau = attributes.authorisedCreditBureau;
					this.authorisedCreditBureauId = attributes.authorisedCreditBureau.id;
				} else {
					this.authorisedCreditBureau = new Models.CreditBureauEntity(attributes.authorisedCreditBureau);
					this.authorisedCreditBureauId = this.authorisedCreditBureau.id;
				}
			} else if (attributes.authorisedCreditBureauId !== undefined) {
				this.authorisedCreditBureauId = attributes.authorisedCreditBureauId;
			}
		}

	}


}
